import { useState } from 'react'
import { MAX_IMAGE_ATTACHMENTS } from '../../../../constants'
import { convertFileToBase64, processImage } from '../utils/imageProcessing'

export const useImageProcessing = () => {

  const [images, setImages] = useState<File[]>([])
  const [processedImages, setProcessedImages] = useState<File[]>([])
  const [imagePreviews, setImagePreviews] = useState<string[]>([])
  const [loading, setLoading] = useState(false)

  const handleImageChange = async (files: FileList) => {
    if (files.length > 0) {
      if (processedImages.length >= MAX_IMAGE_ATTACHMENTS) {
        throw new Error(`画像は${MAX_IMAGE_ATTACHMENTS}枚まで投稿できます`)
      }

      const newFiles = Array.from(files)
      setLoading(true)

      try {
        // 元の画像を保存
        setImages(newFiles)

        const processPromises = newFiles.map((file) => processImage(file))
        const newProcessedImages = await Promise.all(processPromises)
        const combinedProcessedImages = [...processedImages, ...newProcessedImages]
        setProcessedImages(combinedProcessedImages)

        // Base64エンコードされた画像データを生成（プレビュー用）
        const base64Promises = combinedProcessedImages.map((file) => convertFileToBase64(file))
        const newBase64Images = await Promise.all(base64Promises)

        setImagePreviews(newBase64Images)
      } catch {
        throw new Error('画像の処理中にエラーが発生しました。もう一度お試しください。')
      } finally {
        setLoading(false)
      }
    }
  }

  const handleRemoveImage = (index: number) => {
    const newImages = [...images]
    newImages.splice(index, 1)
    setImages(newImages)

    const newProcessedImages = [...processedImages]
    newProcessedImages.splice(index, 1)
    setProcessedImages(newProcessedImages)

    const newPreviews = [...imagePreviews]
    newPreviews.splice(index, 1)
    setImagePreviews(newPreviews)
  }

  return {
    images,
    processedImages,
    imagePreviews,
    loading,
    handleImageChange,
    handleRemoveImage,
  }
}
